const aboutUs = {
    title: 'Chi Siamo',
    subtitle: 'Scopri la passione e l\'esperienza che rendono "La Dolce Vita" la scelta perfetta per le tue avventure in Abruzzo',
    breadcrumb: 'Chi Siamo',
    ourStory: {
        title: 'La Nostra Storia',
        paragraph1: 'Siamo due amici nati e cresciuti in Abruzzo, profondamente legati alla nostra terra. Dopo anni vissuti tra viaggi e scoperte, abbiamo deciso di creare un\'agenzia con un solo obiettivo: far conoscere l\'Abruzzo più autentico a chi cerca un\'esperienza vera, immersiva e senza stress.',
        paragraph2: '',
        paragraph3: ''
    },
    whatWeOrganize: {
        title: 'Organizziamo',
        groupTravel: 'Viaggi personalizzati di gruppo',
        authenticExperiences: 'Esperienze autentiche: cucina tipica, trekking, borghi, natura, artigianato',
        wineTours: 'Tour enogastronomici con produttori locali',
        customActivities: 'Attività su misura: per famiglie, coppie, gruppi, aziende o scuole',
        completeServices: 'Servizi di guida, trasporto e assistenza completa sul territorio'
    },
    mission: {
        title: 'La Nostra Missione',
        subtitle: 'La nostra agenzia nasce con un obiettivo chiaro: aiutarti a vivere l\'Abruzzo in modo semplice, autentico e senza pensieri.\nConosciamo ogni angolo di questa terra — dai sentieri nascosti del Gran Sasso alle spiagge segrete della Costa dei Trabocchi, dai piccoli produttori di vino alle sagre di paese che pochi turisti riescono a trovare.',
        description: ''
    },
    values: {
        sustainability: {
            title: 'Sostenibilità',
            description: 'Promuoviamo un turismo responsabile che rispetta l\'ambiente e supporta le comunità locali.'
        },
        authenticity: {
            title: 'Autenticità',
            description: 'Offriamo esperienze genuine che ti permettono di scoprire il vero spirito dell\'Abruzzo.'
        },
        excellence: {
            title: 'Eccellenza',
            description: 'Ci impegniamo a fornire servizi di qualità superiore e un\'esperienza cliente impeccabile.'
        }
    },
    whyChooseUs: {
        title: 'Perché Scegliere Noi',
        subtitle: 'Perché l\'Abruzzo non si improvvisa. Non è una regione da visitare con l\'orologio alla mano e l\'itinerario copiato da internet. È una terra che va ascoltata, attraversata, sentita. E per farlo nel modo giusto, serve chi la conosce davvero.\nCon noi, non sarai un semplice turista, ma un ospite privilegiato, accompagnato da persone che amano profondamente questa regione e che hanno scelto di condividerne la bellezza con chi la sa apprezzare',
        localExperience: {
            title: 'Esperienza Locale',
            description: 'Conosciamo ogni angolo nascosto e ogni tradizione dell\'Abruzzo, perché ci siamo cresciuti.'
        },
        worryFreeTravel: {
            title: 'Viaggi Senza Pensieri',
            description: 'Pensiamo a tutto noi: trasporti, hotel, ristoranti, attività. Tu goditi solo la vacanza.'
        },
        responsibleTourism: {
            title: 'Turismo Responsabile',
            description: 'Collaboriamo con le realtà locali e promuoviamo un turismo che rispetta l\'ambiente e valorizza le comunità.'
        }
    },
    customerService: {
        title: 'Servizio Clienti Eccezionale',
        subtitle: 'Siamo qui per te, sempre',
        description: 'Il nostro team di assistenza clienti dedicato è disponibile per aiutarti con qualsiasi domanda, preoccupazione o richiesta speciale. Crediamo che un servizio eccezionale sia la base di esperienze di viaggio indimenticabili.',
        responseTime: 'Rispondiamo generalmente entro poche ore durante gli orari di lavoro',
        contactUs: 'Contattaci Ora',
        supportTitle: 'Assistenza Clienti',
        veryFastAnswer: 'Risposta molto veloce',
        personalizedAssistance: 'Assistenza personalizzata per ogni richiesta',
        followUp: 'Follow-up fino alla completa soddisfazione'
    },
    cta: {
        title: 'Pronto per la Tua Avventura?',
        subtitle: 'Unisciti a noi e scopri la magia dell\'Abruzzo attraverso esperienze autentiche e indimenticabili.',
        discoverTrips: 'Scopri i Nostri Viaggi',
        exploreActivities: 'Esplora le Attività',
        exploreDestinations: 'Esplora le Destinazioni',
        exploreCuriosities: 'Esplora le Curiosità'
    }
};

export default aboutUs;
